export const PRIVACY_POLICY_URL =
  "https://drive.google.com/file/d/1DI9yUJSyz52D3NfLcQiXSQhBYdpk70MZ/view?usp=drive_link";
export const CLIENT_AGREEMENT_URL =
  "https://drive.google.com/file/d/13VXhST9t_A-mClGcfMn-krWhlBYLhxaf/view?usp=drive_link";
export const LEGAL_DOCUMENTS_URL =
  "https://drive.google.com/drive/folders/1hEaWlFYazUMD4pJ-Lx-QvgVDR4ma22ps?usp=drive_link";
export const RISK_DISCLOSURE_URL =
  "https://drive.google.com/file/d/1NgV0DeoIQGSTC2O5u3472B7cUmZYkeQM/view?usp=drive_link";
export const IB_AGREEMENT_URL =
  "https://drive.google.com/drive/folders/1Ymu9-LEin9r1Sc8FmKb85Q2l1ieyW85a?zx=intqtl7l7n3w";
